import { EVENTS, MODES, readSelection } from 'store-selector-core';

/**
 * Sticky Click & Collect trigger on the frontpage, PLP and PDP.
 * Expanded when no store is selected; collapses to a circle once a store is
 * chosen. Clicking opens the existing cart store selector flow via the global
 * open-store-selector event.
 */
class StoreSelectorTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#onClick);
    document.addEventListener(EVENTS.STORE_CHANGED, this.#onStoreChanged);
    const { mode, store } = readSelection();
    this.#render(mode === MODES.CLICK_COLLECT && Boolean(store?.id));
    this.hidden = false;
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onClick);
    document.removeEventListener(EVENTS.STORE_CHANGED, this.#onStoreChanged);
  }

  #onClick = () => {
    document.dispatchEvent(new CustomEvent(EVENTS.OPEN_SELECTOR));
  };

  #onStoreChanged = (evt) => {
    const { fulfillmentMode, store } = evt.detail || {};
    this.#render(fulfillmentMode === MODES.CLICK_COLLECT && Boolean(store?.id));
  };

  #render(hasStore) {
    this.classList.toggle('store-trigger--collapsed', hasStore);
    const { selectLabel, changeLabel } = this.button?.dataset || {};
    const label = hasStore ? changeLabel : selectLabel;
    if (!label) return;

    this.button.setAttribute('aria-label', label);
    /* The label is revealed on hover in the collapsed state, so keep the visible
       text in step with aria-label instead of leaving the "select" copy. */
    const labelEl = this.button.querySelector('.store-trigger__label');
    if (labelEl) labelEl.textContent = label;
  }
}

if (!customElements.get('store-selector-trigger')) {
  customElements.define('store-selector-trigger', StoreSelectorTrigger);
}
